import { Injectable } from "@angular/core";
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { environment } from "environments/environment";
import * as moment from "moment";
import { AuthService } from "../auth.service";

export enum UtcToLocalTimeFormat {
  FULL = "full", // 'EEEE, MMMM d, y, h:mm:ss a zzzz'   - Monday, June 15, 2015 at 9:03:01 AM GMT+01:00
  SHORT = "short", // 'd/M/yy, h:mm'                      - 15/6/15, 9:03
  SHORT_DATE = "shortDate", // 'd/M/yy'                            - 15/6/15
  SHORT_TIME = "shortTime", // 'h:mm'                              - 9:03
}

@Injectable()
export class UtilsDateService extends NgbDateParserFormatter {
  readonly DT_FORMAT_ONLYDATE = environment.formatOnlyDate;

  public convertUtcToLocalTime(
    utcDate: string, // UTC ISO-8601
    format: UtcToLocalTimeFormat = UtcToLocalTimeFormat.FULL
  ): string {
    let formatOnlyDate: string = this.getFormatOnlyDateLocal();

    if (format === UtcToLocalTimeFormat.SHORT) {
      let date = moment.utc(utcDate).format(formatOnlyDate);
      let time = moment.utc(utcDate).format(environment.formatHour);
      return `${date}, ${time}`;
    } /* else if (format === UtcToLocalTimeFormat.SHORT_DATE) {
      return new Date(utcDate).toLocaleDateString(currentLanguage);
    } else if (format === UtcToLocalTimeFormat.SHORT_TIME) {
      return new Date(utcDate).toLocaleTimeString(currentLanguage);
    } else if (format === UtcToLocalTimeFormat.FULL) {
      return new Date(utcDate).toString(); 
    }*/ else {
      console.error(`Do not have logic to format utc date, format:${format}`);
      return new Date(utcDate).toString();
    }
  }

  public convertLocalTimeToUtc(localDate: string): string {
    var date = new Date(localDate);
    return date.toUTCString();
  }

  getFormatOnlyDateLocal() {
    var currentLanguage = AuthService.getFromStorage(
      environment.storageLanguageNameApi
    );
    let formatOnlyDate =
      currentLanguage == "es"
        ? environment.formatOnlyDateEs
        : environment.formatOnlyDateEn;
    return formatOnlyDate;
  }

  parse(value: string): NgbDateStruct {
    /*  if (value) {
      value = value.trim();
      let mdt = moment(value, this.DT_FORMAT);
    }
    return null; */
    return;
  }

  format(date: NgbDateStruct): string {
    if (!date) return "";
    let formatOnlyDate: string = this.getFormatOnlyDateLocal();
    let mdt = moment([date.year, date.month - 1, date.day]).format(
      formatOnlyDate
    );
    return mdt;
  }

  convertUtcToDatepicker(utcDate) {
    let localDate: NgbDateStruct = {
      year: moment.utc(utcDate).year(),
      month: moment.utc(utcDate).month() + 1,
      day: moment.utc(utcDate).date(),
    };
    return localDate;
  }

  convertUtcToTimepicker(utcDate) {
    let localTime = moment.utc(utcDate).format(environment.formatHour);
    return localTime;
  }

  convertDatepickerToUtc(date: NgbDateStruct) {
    let utcDate = moment([date.year, date.month - 1, date.day]).format(
      environment.formatOnlyDate
    );
    return utcDate;
  }
}
